<template>
      <h4 class="title-page">{{ tituloDaPagina }}</h4>
</template>

<script>
export default {
  created() {
    this.definirTitulo();
  },
  watch: {
    $route() {
      this.definirTitulo();
    },
  },
  methods: {
    definirTitulo() {
      const meta = this.$route.meta;

      if (meta && meta.tituloDaPagina) {
        this.tituloDaPagina = meta.tituloDaPagina;
      } else {
        console.error(`Nenhum título definido para [${this.$route.path}]`);
        this.tituloDaPagina = null;
      }
    },
  },
  data() {
    return { tituloDaPagina: null };
  },
};
</script>

<style lang="scss" scoped>
  h1 {
    margin-bottom: 5px !important;
  }

  .cabecalho-conteudo {
    margin-bottom: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// CabecalhoDoConteudo.vue?35774cff